export var sponsorDataForm = {
    SponsorName: "",
    Code: "",
    Img: "",
    id: "",
    clientId: "",
};
